<div *ngIf="sortedRepairs.length; else emptyTimeline" class="relative pl-8">
  <!-- Línea vertical -->
  <span class="absolute left-[11px] top-2 bottom-2 w-px bg-gray-200 dark:bg-white/10"></span>

  <div *ngFor="let r of sortedRepairs" class="relative pb-6 last:pb-0">
    <!-- Punto de la severidad -->
    <span
      class="absolute -left-8 top-1 h-3.5 w-3.5 rounded-full ring-4"
      [ngClass]="dotClass(r.severity)"
    ></span>

    <div class="rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
      <div class="flex flex-wrap items-start justify-between gap-2">
        <div>
          <div class="font-semibold text-[#0e1726] dark:text-white">{{ r.title }}</div>
          <div class="text-[11px] text-gray-400 dark:text-white/50">{{ r.date | date: 'dd/MM/yyyy' }}</div>
        </div>
        <span class="rounded-full px-2.5 py-0.5 text-[11px] font-semibold" [ngClass]="severityBadgeClass(r.severity)">
          {{ severityLabel(r.severity) }}
        </span>
      </div>

      <p class="mt-2 text-sm text-gray-600 dark:text-white/70">{{ r.description }}</p>

      <div class="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-500 dark:text-white/60">
        <span class="inline-flex items-center gap-1">
          <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          {{ r.workshop || '—' }}
        </span>
        <span class="inline-flex items-center gap-1 font-semibold text-[#0e1726] dark:text-white">
          <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          ${{ cop(r.cost) }}
        </span>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyTimeline>
  <div class="rounded-xl border border-dashed border-gray-200 dark:border-white/10 p-6 text-center text-sm text-gray-400 dark:text-white/50">
    Sin reparaciones registradas
  </div>
</ng-template>
